import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export default function PinPicker({ lat, lng, locationHint, onPick, testId }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const onPickRef = useRef(onPick);
  onPickRef.current = onPick;

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;
    const hasPin = lat != null && lng != null;
    const map = L.map(containerRef.current).setView(
      hasPin ? [lat, lng] : [51.7356, 0.4685],
      hasPin ? 16 : 12
    );
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "© OpenStreetMap contributors",
    }).addTo(map);
    if (hasPin) {
      markerRef.current = L.marker([lat, lng], { icon: markerIcon }).addTo(map);
    }
    map.on("click", (e) => {
      const { lat: la, lng: ln } = e.latlng;
      if (markerRef.current) markerRef.current.setLatLng([la, ln]);
      else markerRef.current = L.marker([la, ln], { icon: markerIcon }).addTo(map);
      onPickRef.current(la, ln);
    });
    mapRef.current = map;

    if (!hasPin && locationHint) {
      fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(locationHint + ", UK")}&limit=1`)
        .then((r) => r.json())
        .then((d) => {
          const f = d.features?.[0];
          if (f && mapRef.current) {
            mapRef.current.setView([f.geometry.coordinates[1], f.geometry.coordinates[0]], 15);
          }
        })
        .catch(() => {});
    }

    return () => {
      map.remove();
      mapRef.current = null;
      markerRef.current = null;
    };
  }, []);

  return (
    <div>
      <div
        ref={containerRef}
        data-testid={testId}
        className="h-56 w-full rounded-xl border border-[#E4DBD0] dark:border-[#352F2B] overflow-hidden cursor-crosshair"
        style={{ zIndex: 0 }}
      />
      <p className="mt-1.5 text-xs text-[#8A837C] dark:text-[#8E867E]">
        Click the map to drop the pin exactly where the house is. Zoom with scroll or the +/- buttons.
      </p>
    </div>
  );
}
